
import {SAVE_CLEANING_PLAN_SUCCESS} from "../../reducers/cleaningPlanReducer";


export const saveCleaningPlanSuccess = () =>{
    return {
        type: SAVE_CLEANING_PLAN_SUCCESS,
    }
}